import React, { useState, useEffect } from "react";
import { useQuery, useQueries, useQueryClient } from 'react-query'
import { getCumulativeResult, getResultsRSC, getUnits } from "data/Querys";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Loader from 'components/general/Loader'
import { useViewport } from 'components/general/useViewPort'
import PageHeader from "components/common/PageHeader";
import Label from "components/general/Label";
import NotAvailable from "components/common/NotAvailable";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getLongPhaseRSC, getLevelRSC, getPhaseRSC } from "helpers/rsc";
import { PreviousCurrent } from "components/sports/gry/events/common/PreviousCurrent";
import ProgressionRule from "components/common/ProgressionRule";
import GryRotations from "components/sports/gry/views/GryRotations";
import GryResults from "components/sports/gry/views/GryResults";

const GryContext = () => {
  const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

// cumulative result
const { data: dataCumulative, isError: isErrorCumulative, isLoading: isLoadingCumulative } = useQuery({
  queryKey: ['cumulativeData', mirs_competition, mirs_language, getLongPhaseRSC(mirs_rsc)],
  queryFn: getCumulativeResult,
  refetchInterval: 5000,
  staleTime: 5000,
  refetchIntervalInBackground: true,
  notifyOnChangeProps: ['data', 'error'],
  onError: (error) =>
    console.error(`Something went wrong: ${error.message}`),
});

// rotations units
  const { data: dataUnits, isError: isErrorUnits, isLoading: isLoadingUnits } = useQuery(
      {
          queryKey: ['unitsPhase', mirs_competition, mirs_language, getPhaseRSC(mirs_rsc), getLevelRSC(mirs_rsc) === 'PHASE' ? 'S' : 'Y'],
          queryFn: getUnits,
          //refetchInterval: 30000,
          staleTime: Infinity,
          refetchIntervalInBackground: true,
          notifyOnChangeProps: ['data', 'error'],
      }
  );

  // rotations results 
  let queryArray = [];
  dataUnits?.phase?.units?.forEach((unit) => {
      queryArray.push({
          queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, getLongPhaseRSC(mirs_rsc)],
          queryFn: getResultsRSC,
          refetchInterval: 5000,
          staleTime: 5000,
          refetchIntervalInBackground: true,
          notifyOnChangeProps: ['data', 'error'],
      })
  });

  
  const results = useQueries(queryArray);
  const isLoading = isLoadingUnits || isLoadingCumulative || results.some(result => result.isLoading)
  const isError = isErrorUnits || isErrorCumulative || results.some(result => result.isError)

  // console.log(`isLoadingUnits: ${isLoadingUnits}`)
  // console.log(`isLoadingCumulative: ${isLoadingCumulative}`)
  // results?.forEach(result => {
  //   console.log(`isLoadingResult of unit ${result?.data?.results?.eventUnitCode}: ${result.isLoading}`)
  // })

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }

  const realData = results.filter(res => res.data.results)
  const data = realData && Array.isArray(realData) && realData.length > 0 ? realData[0]?.data : undefined;
  if (!data) { return <NotAvailable /> }

  const rscRotations = realData?.map(item => ({rsc: item?.data?.results?.eventUnitCode, rotation: item?.data?.results?.eventUnitCode?.slice(-1)}));
  let currentRotation = dataCumulative?.cumulativeResults?.extendedInfos?.find(ei => ei?.ei_code === 'ROTATION')?.ei_value;
  let current = <></>;
  let currentData
  let disableAllArundTab = true
  if(currentRotation){
    const currentRsc = rscRotations?.find(rotation => rotation?.rotation === currentRotation)?.rsc;
    currentData = realData?.find(item => item?.data?.results?.eventUnitCode === currentRsc)?.data;
    let currentComp = currentData?.results?.items?.filter(item => item?.extendedResultsCurrent)?.find(item => item?.extendedResultsCurrent?.find(erc => erc?.er_code === 'STAGE' && erc?.er_value === 'CURRENT'));
    let previousComp = currentData?.results?.items?.filter(item => item?.extendedResultsCurrent)?.find(item => item?.extendedResultsCurrent?.find(erc => erc?.er_code === 'STAGE' && erc?.er_value === 'LAST'));
    let currentCompCumulative = dataCumulative?.cumulativeResults?.results?.find(result => result?.participant?.code === currentComp?.participant?.code);     
    //console.log(currentResults) //items
    //console.log(dataCumulative) //cumulativeResults.results
    if (dataCumulative?.cumulativeResults?.results && currentData?.results?.items && Array.isArray(dataCumulative?.cumulativeResults?.results) && Array.isArray(currentData?.results?.items)){
      disableAllArundTab = false
      const extradata = dataCumulative.cumulativeResults.results.map(res => {
           const result = currentData.results.items.find(r => r?.participant?.code === res?.participant?.code);
           const startOrderObject = {startSortOrder: result?.startSortOrder, startOrder: result?.startOrder}
           const eslObjext = result?.extCompetitor ? {extCompetitor: result?.extCompetitor} : {} 
           return {...res, ...startOrderObject, ...eslObjext}
          }
        );
        
        dataCumulative.cumulativeResults.results = extradata;
    }
    
    current = <PreviousCurrent current={currentComp} previous={previousComp} cumulative={currentCompCumulative} />
  }
  
  return (
    <>
      <PageHeader data={data} title={data?.results?.eventUnit?.phase?.description}/>
      <div className='mirs-page-container'>
      {current}
      <ProgressionRule key="progress-component" data={data?.config} filter={{type: ['QUALIFICATION'], code: ['QUAL_RULE']}} itemData={'value'} />
      <Tabs id="mirs-navsport" defaultActiveKey={`1-${mirs_rsc}` } className="mb-3 mirs-tab-result" >
        <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='HeaderRotations' />)} disabled={false} >
          <GryRotations data={realData} currentRotation={currentRotation}/>
        </Tab>
        <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='HeaderResultsAllAround' />)} disabled={disableAllArundTab} >
          <GryResults data={dataCumulative} currentRotation={currentRotation} currentData={currentData}/>
        </Tab>
      </Tabs>
      </div>

    </>
  );
};

export default GryContext;
